import { useEffect, useState } from "react";
import PlanosDescricaoContent from "../../PageDescription/Planos/PlanosDescricaoContent";
import api from "../../Services/api";

const PatrimonioPlano = (props: any) => {
  const [rendaFixa, setRendaFixa] = useState<any[]>([]);
  const [rendaVariavel, setRendaVariavel] = useState<any[]>([]);
  const [rendaOutros, setRendaOutros] = useState<any[]>([]);
  const [total, setTotal] = useState<any>();
  const [totalInfo, setTotalInfo] = useState<any>();
  const [beneficios, setBeneficios] = useState<any>();
  const [Aconceder, setAconceder] = useState<any>();
  const [dataTabelaAssistidos, setDataTabelaAssistidos] = useState<any[]>();

  const [_data, set_Data] = useState<any[]>([]);

  useEffect(() => {
    api
      .get(props.url)
      .then((response) => {
        response.data.results.map((item: any) => {
          if (item.Title === "rendaFixa") {
            setRendaFixa(item.Descricao.toLocaleString("pt-BR"));
          }

          if (item.Title === "rendaVariavel") {
            setRendaVariavel(item.Descricao.toLocaleString("pt-BR"));
          }

          if (item.Title === "outros") {
            setRendaOutros(item.Descricao.toLocaleString("pt-BR"));
          }

          if (item.Title === "valorTotal") {
            setTotal(item.Descricao.toLocaleString("pt-BR"));
          }

          if (item.Title === "valorInfo") {
            setTotalInfo(item.Descricao);
          }

          if (item.Title === "beneficios") {
            setBeneficios(item.Descricao.toLocaleString("pt-BR"));
          }

          if (item.Title === "conceder") {
            setAconceder(item.Descricao.toLocaleString("pt-BR"));
          }

          if (item.Title === "data") {
            set_Data(item.Descricao);
          }

          return true;
        });
      })
      .catch((err) => {
        throw new Error(err);
      });
  }, [props.url, rendaFixa, rendaOutros, rendaVariavel]);

  useEffect(() => {
    api
      .get(props.urlTable)
      .then((response) => {
        var tempResults = response.data.results;
        setDataTabelaAssistidos(tempResults);
      })
      .catch((err) => {
        throw new Error(err);
      });
  }, [props.urlTable]);

  return (
    <div className="_the-content page-planos pb-10">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-7">
            <span className="text-medium font-14">
              Data de Referência: {_data}{" "}
            </span>
          </div>
          <div className="col-md-4 col-lg-3 d-none d-md-inline-block"></div>
        </div>
        <br></br>
        {total && (
          <>
            <div className="row justify-content-center">
              <div className="col-md-6 col-lg-7 mb-10">
                <h2> Patrimônio </h2>
              </div>
              <div className="col-md-4 col-lg-3 d-none d-md-inline-block">
                <a
                  rel="noreferrer"
                  href="https://participante.forluz.org.br/"
                  target="_blank"
                  className="btn btn-primary rounded px5 py-3"
                >
                  {" "}
                  Área do participante{" "}
                </a>
              </div>
            </div>
            <div className="row align-items-center justify-content-center">
              <div className="col-md-4 offset-lg-1">
                <div className="page-planos__patrimonio text-center text-white flex-column mx-auto">
                  <p className="valor"> {total} </p>
                  <p className="info2"> {totalInfo} </p>
                </div>
              </div>
              <div className="col-md-4 offset-md-2 offset-lg-1">
                <div className="page-planos__desc mt-6 mt-lg-0">
                  <div className="line">
                    <p>
                      <strong> Renda Fixa </strong> <br /> {rendaFixa}{" "}
                    </p>
                  </div>
                  <div className="line">
                    <p>
                      <strong> Renda Variável </strong> <br />
                      {rendaVariavel}{" "}
                    </p>
                  </div>
                  <div className="line">
                    <p>
                      <strong> Outros </strong> <br /> {rendaOutros}{" "}
                    </p>
                  </div>
                </div>

                <a
                  href="#"
                  target="_blank"
                  className="btn btn-primary rounded px5 py-3 d-md-none"
                >
                  {" "}
                  Área do participante{" "}
                </a>
              </div>
            </div>
          </>
        )}
        <div className="row align-items-center justify-content-center">
          {/* <Tabela url={props.urlTable} /> */}

          {beneficios && Aconceder && dataTabelaAssistidos && (
            <>
              {dataTabelaAssistidos.slice(0, 2).map((item, index) => (
                <div className="col-md-5 mb-5 mb-md-0 mt-10" key={index}>
                  <h3> {item.Title} </h3>
                  <p className="mb-0"> {item.Descricao} </p>
                </div>
              ))}

              <div className="col-md-5 mb-5 mb-md-0 mt-10">
                <h3> Beneficios pagos </h3>
                <p className="mb-0">{beneficios} </p>
              </div>

              <div className="col-md-5 mb-md-0 mt-10">
                <h3> A conceder </h3>
                <p className="mb-0"> {Aconceder}</p>
              </div>
            </>
          )}
          {/* {props.htmlPart} */}
        </div>
        <br></br>

        <PlanosDescricaoContent page={props.page} items={props.items}></PlanosDescricaoContent>
      </div>
    </div>
  );
};
export default PatrimonioPlano;
